import React, { useEffect, useState } from 'react';
import { translate } from '../../../Services/translation';
import { ServicePoint } from '../types/ServicePoint';
import Input from '../../Inputs/Input';
import RadioButton from '../../Inputs/Radiobutton';
import { useDispatch } from 'react-redux';
import { setSelectedServicePoint } from '../../../Actions/Checkout.action';
import { getServicePoints } from '../services/PostnordService';

const ServicePointLocator = ({
  selectedServicePointId,
  validationErrors,
}: {
  selectedServicePointId?: string;
  validationErrors: any;
}) => {
  const [servicePointList, setServicePointList] = useState<ServicePoint[]>(
    []
  );
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [streetName, setStreetName] = useState<string>('');
  const [city, setCity] = useState<string>('');
  const dispatch = useDispatch();

  useEffect(() => {
    if (validationErrors) {
      setErrorMessage(validationErrors['selectedServicePointId']);
    }
  }, [validationErrors]);

  const onSubmit = async (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    try {
      event.preventDefault();
      setErrorMessage('');
      setIsLoading(true);

      if (city.length == 0 || streetName.length == 0) {
        setErrorMessage(translate('postnord.input.empty'));
        return;
      }
      const response = await getServicePoints(city, streetName);
      const servicePointResult = await response.json();

      if (servicePointResult?.error != null) {
        onError(servicePointResult.error);
      } else {
        setServicePointList(servicePointResult?.servicePoints);
      }
    } catch (error) {
      onError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onError = (error: React.SetStateAction<string>) => {
    setErrorMessage(error);
    setServicePointList([]);
  };

  const servicePoints = servicePointList?.map((servicePoint) => {
    const stateKey = 'service-point';
    const name = servicePoint.name;
    const id = servicePoint.id;
    return (
      <RadioButton
        key={`${stateKey}-${servicePoint.id}`}
        label={name}
        value={id}
        name={stateKey}
        checked={id == selectedServicePointId}
        onChange={() =>
          dispatch(setSelectedServicePoint(id, name))
        }
      />
    );
  });

  const inputFields = (
    <div className="flex flex-col gap-2">
      <h4>{translate(`postnord.title`)}</h4>
      <div className="flex flex-col gap-4">
        <Input
          label={translate(`postnord.input.streetname`)}
          type="text"
          inputSize="large"
          placeholder={translate(`postnord.placeholder.streetname`)}
          disabled={isLoading}
          value={streetName}
          onChange={(e) => setStreetName(e.target.value)}
        />
        <Input
          label={translate(`postnord.input.city`)}
          type="text"
          inputSize="large"
          placeholder={translate(`postnord.placeholder.city`)}
          disabled={isLoading}
          value={city}
          onChange={(e) => setCity(e.target.value)}
        />
      </div>
    </div>
  );

  return (
    <>
      {inputFields && (
        <form
          className="flex flex-col gap-4"
          onSubmit={(e) => onSubmit(e)}
        >
          {inputFields}
          <button
            className="btn btn--primary btn--medium w-full"
            type="submit"
            disabled={isLoading}
          >
            {translate(`postnord.button.find`)}
          </button>
        </form>
      )}
      {servicePoints && (
        <div className="flex flex-col gap-4">{servicePoints}</div>
      )}
      {errorMessage && (
        <div className="text-lg text-error-500">{errorMessage}</div>
      )}
    </>
  );
};

export default ServicePointLocator;
